import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import './assets/css/App.custom.css';

// Context
import { AuthProvider } from './context/AuthContext';

// Components
import Navigation from './components/Navigation';
import Footer from './components/Footer';

// Pages
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import Dashboard from './pages/Dashboard';
import PendaftaranTA from './pages/PendaftaranTA';
import Bimbingan from './pages/Bimbingan';
import Seminar from './pages/Seminar';
import VerifikasiAkun from './pages/VerifikasiAkun';
import KelolaTugasAkhir from './pages/KelolaTugasAkhir';
import KelolaSeminar from './pages/KelolaSeminar';
import Admin from './pages/Admin';
import MahasiswaBimbingan from './pages/MahasiswaBimbingan';
import PendingAssignments from './pages/PendingAssignments';
import Profile from './pages/Profile';

// Custom Routes
import PrivateRoute from './components/PrivateRoute';
import RoleRoute from './components/RoleRoute';
import PublicRoute from './components/PublicRoute';

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="d-flex flex-column min-vh-100">
          <Navigation />
          <main className="main-content flex-grow-1">
            <Routes>
              {/* Public Routes - hanya dapat diakses jika belum login */}
              <Route path="/login" element={
                <PublicRoute>
                  <Login />
                </PublicRoute>
              } />
              <Route path="/register" element={
                <PublicRoute>
                  <Register />
                </PublicRoute>
              } />
              <Route path="/forgot-password" element={
                <PublicRoute>
                  <ForgotPassword />
                </PublicRoute>
              } />
              
              {/* Private Routes (requires authentication) */}
              <Route path="/dashboard" element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              } />
              
              {/* Mahasiswa Routes */}
              <Route path="/pendaftaran-ta" element={
                <RoleRoute allowedRoles={['mahasiswa']}>
                  <PendaftaranTA />
                </RoleRoute>
              } />
              <Route path="/bimbingan" element={
                <RoleRoute allowedRoles={['mahasiswa', 'dosen', 'pj']}> {/* Added 'pj' role */}
                  <Bimbingan />
                </RoleRoute>
              } />
              <Route path="/seminar" element={
                <RoleRoute allowedRoles={['mahasiswa', 'dosen']}>
                  <Seminar />
                </RoleRoute>
              } />
              
              {/* Dosen Routes */}
              <Route path="/mahasiswa-bimbingan" element={
                <RoleRoute allowedRoles={['dosen']}>
                  <MahasiswaBimbingan />
                </RoleRoute>
              } />
              <Route path="/pending-assignments" element={
                <RoleRoute allowedRoles={['dosen']}>
                  <PendingAssignments />
                </RoleRoute>
              } />
              <Route path="/mahasiswa-uji" element={
                <RoleRoute allowedRoles={['dosen']}>
                  <Seminar />
                </RoleRoute>
              } />
              
              {/* PJ Routes - Explicitly require verification */}
              <Route path="/verifikasi-akun" element={
                <RoleRoute allowedRoles={['pj']}>
                  <VerifikasiAkun />
                </RoleRoute>
              } />
              <Route path="/kelola-ta" element={
                <RoleRoute allowedRoles={['pj']}>
                  <KelolaTugasAkhir />
                </RoleRoute>
              } />
              <Route path="/kelola-seminar" element={
                <RoleRoute allowedRoles={['pj']}>
                  <KelolaSeminar />
                </RoleRoute>
              } />
              <Route path="/admin" element={
                <RoleRoute allowedRoles={['pj']}>
                  <Admin />
                </RoleRoute>
              } />
              
              {/* Profile Route - accessible to all authenticated users */}
              <Route path="/profile" element={
                <PrivateRoute>
                  <Profile />
                </PrivateRoute>
              } />
              
              {/* Default Route - arahkan ke dashboard jika sudah login, atau ke login jika belum */}
              <Route path="*" element={
                <PrivateRoute>
                  <Navigate to="/dashboard" />
                </PrivateRoute>
              } />
              <Route path="/" element={<Navigate to="/dashboard" />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
